import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface DeleteWidgetV2Result {
  success: boolean;
  error?: string;
}

export const deleteWidgetV2UseCase = async (
  dashboardId: string,
  widgetId: string,
): Promise<DeleteWidgetV2Result> => {
  try {
    const authContext = store.getState().yourSlice.authContext;
    if (!authContext) {
      return { success: false, error: "Not authenticated" };
    }
    await apiUseCases.deleteWidgetV2(
      authContext.customerNamespace,
      dashboardId,
      widgetId,
    );

    return { success: true };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to delete widget").message,
    };
  }
};
